// 备注：在setinterval中使用aysnc await语法，部分浏览器会报unexpected token function（建议使用.then()）
import axios from 'axios'
var config = require('../js/config.js')
var utils = require('./utils/utility.js')

import badNetwork from '../mp3/badNetwork.mp3'

// 默认请求公共地址、头部信息
var domainUrl = config.address

var domainUrl2 = config.address2

var commomHeaders = config.commomHeaders

// post请求
var post = function (url, data) {
	data = data || '';

	return new Promise(function (resolve, reject) {
		axios({
			method: 'post',
			url: domainUrl + url,
			headers: commomHeaders,
			data: data
		})
		.then(function (res) {
			resolve(res.data)
		})
		.catch(function (error) {
			var url = badNetwork
			var audio = new Audio(url);
			audio.src = url;
			audio.play();
			utils.messageError('网络信号不良，请稍后再试')
			// console.log('error', error)
			utils.hideLoading()
			reject(error)
		})
	})
}

// post请求
var post2 = function (url, data) {
	data = data || '';

	return new Promise(function (resolve, reject) {
		axios({
			method: 'post',
			url: 'http://'+domainUrl2 + url,
			headers: commomHeaders,
			data: data
		})
		.then(function (res) {
			resolve(res.data)
		})
		.catch(function (error) {

			var url = badNetwork
			var audio = new Audio(url);
			audio.src = url;
			audio.play();
			utils.messageError('网络信号不良，请稍后再试')
			// console.log('error', error)
			utils.hideLoading()
			reject(error)
		})
	})
}



export {
	post,
	post2
}



//////////////////
// WEBPACK FOOTER
// ./static/js/request.js
// module id = tY+N
// module chunks = 1